import { LOCAL_STORAGE_KEYS } from '@/constants';

export const ONBOARDING_LOCAL_STORAGE_KEYS = {
	USER_ANSWERS: 'quiz_user_answers',
	GROUP_NUMBER: 'quiz_group_number',
	QUESTION_NUMBER: 'quiz_question_number',
	USER_EMAIL: LOCAL_STORAGE_KEYS.USER_EMAIL,
	USER_NAME: 'onboarding_user_name',
	USER_INSTAGRAM: 'onboarding_user_instagram',
	USER_ID: LOCAL_STORAGE_KEYS.USER_ID,
	USER_TEMPORARY_TOKEN: 'auth_temporary_token',
	USER_ALREADY_EXISTS: 'onboarding_user_already_exists',
	EMAIL_STATUS: 'onboarding_email_status',
	TEMPORARY_TOKEN: 'onboarding_temporary_token',
	PLAN: 'onboarding_plan',
	TOKEN: 'auth_token',
	LOGIN_TYPE: 'onboarding_login_type',
	METHOD: 'onboarding_payment_method',
	TRANSACTION_ID: 'onboarding_transaction_id',
	FB_EVENT_ADD_TO_CART: 'event_AddToCart',
	FB_EVENT_INITIATE_CHECKOUT: 'event_InitiateCheckout',
	POPUP_FINISHER: 'onboarding_popup_finisher',
	TIMER: 'onboarding_timer',
	UPSELLS: 'onboarding_upsells',
	CROSS_SALE: 'onboarding_cross_sale',
	CROSS_SALE_DISCOUNT: 'onboarding_cross_sale_discount',
	USER_GOAL: 'user_goal',
	QUIZ_VERSION: 'quiz_version',
	PAYMENT_PLAN: 'payment_plan',
	MULTI_PLANS: 'multi_plans',
};
